import { createStore, Store } from 'vuex'
import createPersistedState from 'vuex-persistedstate';
export default createStore({
  state: {
    isAuthenticated:false,
    token:''
  },
  mutations: {
    loginUser(state) {
      state.isAuthenticated = true;
    },
    setToken(state,token) {
      state.token = token;
    }
  },
  actions: {
    loginUser({ commit }, body) {
      commit("loginUser");
    }, 
  },
  plugins: [createPersistedState({ storage: window.sessionStorage })],
  getters: {
    isAuthenticatedUser(state,getters){
      return state.isAuthenticated;
    },
    getToken(state){
      return state.token;
    }
  },
  modules: {},
});